import { render } from "./PlatMerchantList.vue?vue&type=template&id=40ec50bc&scoped=true"
import script from "./PlatMerchantList.vue?vue&type=script&lang=js"
export * from "./PlatMerchantList.vue?vue&type=script&lang=js"

import "./PlatMerchantList.vue?vue&type=style&index=0&id=40ec50bc&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40ec50bc"]])

export default __exports__